import React from 'react'
import Footer from '../components/Footer'
import Navbar from "../components/Navbar"
import PreNav from "../components/PreNav"

const Homepage = () => {
  return (
    <>
      <PreNav/>
      <Navbar/>
      <section style={{backgroundImage:"url('https://yevgenysim-turkey.github.io/shopper/assets/img/covers/cover-5.jpg')"}}>
        <div className="container">
          <div className="row py-12">
            <div className="col-12 col-md-6 col-lg-5 col-xl-4 offset-md-1">
              <h1>Summer Sale</h1>
              <h2 className="display-1 text-primary">-70%</h2>
              <h5 className="mt-n4 mb-8">with promo code CN67EW*</h5>
              <a className="btn btn-dark" href="/collections/framed-art">
                Shop Now <i className="bi bi-arrow-right ml-2"></i>
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Categories */}
      <section className="pt-6">
        <div className="container-fluid px-3 px-md-6">
          <div className="row mx-n3">
            <div className="col-12 col-sm-4 d-flex flex-column px-3">
              {/* Card*/}
              <div className="card card-xl mb-3 mb-sm-0" style={{minHeight: '280px'}}>
                {/* Background */}
                <div className="card-bg">
                  <div className="card-bg-img bg-cover" style={{backgroundImage: 'url(https://yevgenysim-turkey.github.io/shopper/assets/img/products/product-22.jpg)'}} />
                </div>
                {/* Body */}
                <div className="card-body my-auto">
                  {/* Heading */}
                  <h5 className="mb-0">Summer Hats</h5>
                  {/* Link */}
                  <a className="btn btn-link stretched-link px-0 text-reset" href="/collections/framed-art">
                    Shop Now <i className="bi bi-arrow-right ml-2" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-4 d-flex flex-column px-3">
              {/* Card*/}
              <div className="card card-xl mb-3 mb-sm-0" style={{minHeight: '280px'}}>
                {/* Background */}
                <div className="card-bg">
                  <div className="card-bg-img bg-cover" style={{backgroundImage: 'url(https://yevgenysim-turkey.github.io/shopper/assets/img/products/product-23.jpg)'}} />
                </div>
                {/* Body */}
                <div className="card-body my-auto">
                  {/* Heading */}
                  <h5 className="mb-0">Men Hats</h5>
                  {/* Link */}
                  <a className="btn btn-link stretched-link px-0 text-reset" href="/collections/framed-art">
                    Shop Now <i className="bi bi-arrow-right ml-2" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-4 d-flex flex-column px-3">
              {/* Card*/}
              <div className="card card-xl bg-cover bg-hover" style={{minHeight: '280px'}}>
                {/* Background */}
                <div className="card-bg">
                  <div className="card-bg-img bg-cover" style={{backgroundImage: 'url(https://yevgenysim-turkey.github.io/shopper/assets/img/products/product-24.jpg)'}} />
                </div>
                {/* Body */}
                <div className="card-body my-auto">
                  {/* Heading */}
                  <h5 className="mb-0">Floral Dresses</h5>
                  {/* Link */}
                  <a className="btn btn-link stretched-link px-0 text-reset" href="/collections/framed-art">
                    Shop Now <i className="bi bi-arrow-right ml-2" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* products */}
      <section className='py-12'>
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-6">
              {/* Card */}
              <div className="card card-lg">
                {/* Circle */}
                <div className="card-circle card-circle-lg card-circle-right">
                  <strong className="font-size-xs text-decoration-line-through opacity-80">$99.00</strong>
                  <span className="font-size-h6 font-weight-bold">$59.00</span>
                </div>
                {/* Image */}
                <img className="card-img-top" src="https://yevgenysim-turkey.github.io/shopper/assets/img/products/product-30.jpg" alt="..." />
                {/* Body */}
                <div className="card-body position-relative mx-6 mx-lg-11 mt-n11 bg-white text-center">
                  {/* Heading */}
                  <h4 className="mb-0">Cropped Trousers</h4>
                  {/* Link */}
                  <a className="btn btn-link stretched-link px-0 text-reset" href="/collections/framed-art">
                    Shop Now <i className="fe fe-arrow-right ml-2" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              {/* Card */}
              <div className="card card-lg">
                {/* Circle */}
                <div className="card-circle card-circle-lg card-circle-right">
                  <strong className="font-size-xs text-decoration-line-through opacity-80">$99.00</strong>
                  <span className="font-size-h6 font-weight-bold">$59.00</span>
                </div>
                {/* Image */}
                <img className="card-img-top" src="https://yevgenysim-turkey.github.io/shopper/assets/img/products/product-31.jpg" alt="..." />
                {/* Body */}
                <div className="card-body position-relative mx-6 mx-lg-11 mt-n11 bg-white text-center">
                  {/* Heading */}
                  <h4 className="mb-0">Leather Sneakers</h4>
                  {/* Link */}
                  <a className="btn btn-link stretched-link px-0 text-reset" href="/collections/framed-art">
                    Shop Now <i className="fe fe-arrow-right ml-2" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* features */}
      <section className="py-9 bg-light">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-6 col-lg-3">
              {/* Item */}
              <div className="d-flex mb-6 mb-lg-0">
                {/* Icon */}
                <i className="bi bi-truck font-size-lg text-primary" />
                {/* Body */}
                <div className="ml-6">
                  {/* Heading */}
                  <h6 className="heading-xxs mb-1">
                    Free shipping
                  </h6>
                  {/* Text */}
                  <p className="mb-0 font-size-sm text-muted">
                    From all orders over $100
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3">
              {/* Item */}
              <div className="d-flex mb-6 mb-lg-0">
                {/* Icon */}
                <i className="bi bi-arrow-repeat font-size-lg text-primary" />
                {/* Body */}
                <div className="ml-6">
                  {/* Heading */}
                  <h6 className="mb-1 heading-xxs">
                    Free returns
                  </h6>
                  {/* Text */}
                  <p className="mb-0 font-size-sm text-muted">
                    Return money within 30 days
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3">
              {/* Item */}
              <div className="d-flex mb-6 mb-md-0">
                {/* Icon */}
                <i className="bi bi-lock font-size-lg text-primary" />
                {/* Body */}
                <div className="ml-6">
                  {/* Heading */}
                  <h6 className="mb-1 heading-xxs">
                    Secure shopping
                  </h6>
                  {/* Text */}
                  <p className="mb-0 font-size-sm text-muted">
                    You're in sabi hands
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3">
              {/* Item */}
              <div className="d-flex">
                {/* Icon */}
                <i className="bi bi-tag font-size-lg text-primary" />
                {/* Body */}
                <div className="ml-6">
                  {/* Heading */}
                  <h6 className="mb-1 heading-xxs">
                    Over 10,000 Styles
                  </h6>
                  {/* Text */}
                  <p className="mb-0 font-size-sm text-muted">
                    We have everything you need
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer/>
    </>
  )
}

export default Homepage